var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{attrs:{"stroke":"#ffffff","stroke-width":"0","fill":"#ffffff32"}},[_c('circle',{attrs:{"cx":"0","cy":"120","r":"8","fill":"#ffffff00"}}),_c('circle',{attrs:{"cx":"0","cy":"120","r":"6"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }